const TemProdutoPesavelEnum = {
    SIM: 'Sim',
    NAO: 'Nao'
}

export default TemProdutoPesavelEnum;